import styled from 'styled-components'

// 1. The Main Container
export const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    color: black;
    font-weight: lighter;
`

// 2. The Squiggly Line
export const LineWrapper = styled.div`
    flex-grow: 1;
    height: 100%;
    overflow: hidden;
    position: relative;
    align-items: center;
`

// 3. The Arrow Tip
export const ArrowTipWrapper = styled.div`
    width: 14px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: -3px;
`
